import { gql } from "@apollo/client";
import type { ApolloCache } from "@apollo/client";

/**
 * GraphQL fields used by both Create and Update mutations.
 * Matches the schema from the private API.
 */
export const CUSTOM_URL_FIELDS = `
  id
  tenantId
  slug
  targetType
  targetLandingPageId
  targetPath
  isActive
  createdAt
  updatedAt
`;

export const CREATE_CUSTOM_URL = gql`
  mutation CreateCustomUrl(
    $slug: String!
    $targetType: String!
    $targetLandingPageId: String
    $targetPath: String
    $isActive: Boolean
  ) {
    createCustomUrl(
      slug: $slug
      targetType: $targetType
      targetLandingPageId: $targetLandingPageId
      targetPath: $targetPath
      isActive: $isActive
    ) {
      ${CUSTOM_URL_FIELDS}
    }
  }
`;

export const UPDATE_CUSTOM_URL = gql`
  mutation UpdateCustomUrl(
    $id: String!
    $slug: String
    $targetType: String
    $targetLandingPageId: String
    $targetPath: String
    $isActive: Boolean
  ) {
    updateCustomUrl(
      id: $id
      slug: $slug
      targetType: $targetType
      targetLandingPageId: $targetLandingPageId
      targetPath: $targetPath
      isActive: $isActive
    ) {
      ${CUSTOM_URL_FIELDS}
    }
  }
`;

export const DELETE_CUSTOM_URL = gql`
  mutation DeleteCustomUrl($id: String!) {
    deleteCustomUrl(id: $id) {
      id
    }
  }
`;

export const GET_CUSTOM_URL = gql`
  query CustomUrl($id: String!) {
    CustomUrl(id: $id) {
      ${CUSTOM_URL_FIELDS}
    }
  }
`;

/**
 * Drop the cached custom URL listing from Apollo's cache. `refetchQueries`
 * by query name only refreshes *active* queries, and the listing is
 * unmounted while the create/edit pages are open — so without this the
 * list shows stale cached rows when the user navigates back. Evicting
 * forces a fresh fetch the next time the listing mounts.
 */
export function evictCustomUrlListings(cache: ApolloCache<unknown>) {
  cache.evict({ fieldName: "allCustomUrls" });
  cache.evict({ fieldName: "_allCustomUrlsMeta" });
  cache.gc();
}
